import React from "react";
import { useForm, Controller } from "react-hook-form";
import { useUserLoginMutation } from "../../utils/user.utils";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAuth } from "../../redux/slice/authSlice";
import useIsAuth from "../../hooks/useIsAuth";
import { setToken } from "../../utils/token.utils";

function LoginForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useIsAuth();

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const { loading, userLogin } = useUserLoginMutation(["userLogin"]);

  const onSubmit = async (data) => {
    const afterLogin = await userLogin({
      emailOrUsername: data?.emailOrUsername,
      password: data?.password
    });

    if (afterLogin?.status === 200) {
      dispatch(
        setAuth({
          isAuth: true,
          user: afterLogin?.data?.user,
          token: afterLogin?.data?.accessToken
        })
      );
      setToken(afterLogin?.data?.accessToken);
      navigate("/");
    }
  };

  return (
    <form
      className="row needs-validation  text-start g-3"
      noValidate
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="col-12">
        <label htmlFor="emailOrUsername" className="form-label">
          Email or Username
        </label>
        <Controller
          name="emailOrUsername"
          control={control}
          defaultValue=""
          rules={{ required: true }}
          render={({ field }) => (
            <input
              type="text"
              id="emailOrUsername"
              placeholder="Email or Username"
              className={`form-control ${errors.emailOrUsername ? "is-invalid" : ""}`}
              {...field}
            />
          )}
        />
        {errors.emailOrUsername && (
          <div className="invalid-feedback">This is a required field!</div>
        )}
      </div>
      <div className="col-12">
        <label htmlFor="password" className="form-label">
          Password
        </label>
        <Controller
          name="password"
          control={control}
          defaultValue=""
          rules={{ required: true }}
          render={({ field }) => (
            <input
              type="password"
              id="password"
              placeholder="********"
              className={`form-control ${errors.password ? "is-invalid" : ""}`}
              {...field}
            />
          )}
        />
        {errors.password && <div className="invalid-feedback">This is a required field!</div>}
      </div>
      <div className="col-12">
        <div className="form-check">
          <Controller
            name="remember"
            control={control}
            defaultValue={false}
            render={({ field }) => (
              <>
                <label htmlFor="remember" className="form-check-label">
                  Remember
                </label>
                <input type="checkbox" id="remember" className={`form-check-input`} {...field} />
              </>
            )}
          />
        </div>
      </div>
      <div className="col-12">
        <button disabled={loading} className="btn btn-primary w-100" type="submit">
          {loading ? "Signing..." : "Sign In"}
        </button>
      </div>
    </form>
  );
}

export default LoginForm;
